import { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';

import { FadeWrapperProps } from './fadeWrapper.types';

const VARIANTS = {
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  },
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5
    }
  }
};
const FadeWrapper: React.FC<PropsWithChildren<FadeWrapperProps>> = ({
  children,
  className,
  dataTestId,
  style
}) => {
  return (
    <motion.div
      animate="visible"
      className={className}
      data-testid={dataTestId}
      initial="hidden"
      exit="exit"
      style={style}
      variants={VARIANTS}
    >
      {children}
    </motion.div>
  );
};

export default FadeWrapper;
